import axios from "axios";
import {
  Toast
} from 'vant';
import {
  jsSdk
} from './api'
import router from "../router/index"

//一页多少条
export const pageSize = 10;



// import {
//   resolve
// } from "core-js/fn/promise";
const imageCoversion = require("image-conversion");
//上传图片
export function uploadimg(file) {
  const api_token = localStorage.getItem("token");
  const formdata = new FormData();
  // console.log(file.file.type, 'type');
  const isJpgOrPng = file.file.type === 'image/jpeg' || file.file.type === 'image/png';
  if (!isJpgOrPng) {
    Toast('上传图片只能是JPG或PNG 格式!');
    return false;
  }
  formdata.append('api_token', api_token)
  return new Promise((resolve, reject) => {
    imageCoversion
      .compressAccurately(file.file, 300)
      .then((res1) => {
        console.log(file.file, '-----------file.file');
        console.log(res1, '-----------res1');
        formdata.append('file', res1)

        let config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
        // return new Promise((resolve, reject) => {
        axios.post("/api/uploadImg", formdata, config).then(res => {
          console.log(res.data);
          if (res.data.code == 0) {
            resolve(res.data.data)
          } else {
            Toast(res.data.message)
            resolve(false)
          }
        }).catch(err => {
          Toast(err)
          reject(err)
        })
        // })
      })
      .catch((res) => {
        console.log(res);
        Toast("上传失败，请稍后重试");
      });
  })
}



export function getTimer(end_time) {
  let end = new Date(end_time).getTime();
  let now = new Date().getTime();
  let endFont = parseInt((Number(end) - now) / 1000);
  if (endFont > 86400) {
    return parseInt((end - now) / (1000 * 60 * 60 * 24)) + '天';
  } else if (endFont <= 86400 && endFont > 3600) {
    return parseInt((end - now) / (3600 * 1000)) + '小时';
  } else if (endFont < 3600 && endFont > 60) {
    return parseInt((end - now) / (60 * 1000)) + '分钟'
  } else {
    return null;
  }
}

export function getCode() {
  let usercode = getQueryString('usercode');
  // console.log(u1);
  if (usercode) {
    sessionStorage.setItem('userCode', usercode);
    // window.location.href = HERF + '/h5/#/sq'
  }
}
//获取浏览器上的参数
export function getQueryString(variable) {
  let herf = window.location.href;
  let num = herf.indexOf("?") + 1;
  let query = herf.substring(num);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

export function questionFont(t) {
  //0-填写中 1-配额已满 2-甄别终止 3-甄别完成 4-正常完成
  if (t == 4 || t == 3) {
    return '已完成，感谢您的参与'
  } else if (t == 2) {
    return '很遗憾，您不符合本次任务的要求'
  } else if (t == 1) {
    return '很遗憾，本次所需人数已满'
  } else if (t == 99) {
    return '很遗憾，本次任务已过期'
  } else if (t == 98) {
    return '本次任务未开始'
  }
}

export function questionType(t) {
  t = Number(t)
  let qt = ''
  switch (t) {
    case 1:
      qt = '投票';
      break;
    case 2:
      qt = '单选';
      break;
    case 3:
      qt = '多选';
      break;
    case 4:
      qt = '问答';
      break;
    case 5:
      qt = '标注';
      break;
    default:
      qt = ''
  }
  return qt
}

//获取是否是微信端打开
export function getOpenType() {
  //微信端（微信浏览器）打开进手机端  其他的都进pc端
  var ua = navigator.userAgent.toLowerCase();
  var isWeixin = ua.indexOf('micromessenger') != -1;
  // console.log(isWeixin,'isWeixin---------------------');
  if (isWeixin) {
    return true
  } else {
    return false
  }
}
//毫秒数转换为时分秒
export function formatDuring(t) {
  if (t < 60000) {
    return parseInt(((t % 60000) / 1000)) + "秒";
  } else if ((t >= 60000) && (t < 3600000)) {
    return getString((t % 3600000) / 60000) + "分" + getString((t % 60000) / 1000) + "秒";
  } else {
    return getString(t / 3600000) + "时" + getString((t % 3600000) / 60000) + "分" + getString((t % 60000) / 1000) + "秒";
  }
}

function getString(t) {
  t = parseInt(t)
  let m = "";
  if (t > 0) {
    if (t < 10) {
      m = "0" + t;
    } else {
      m = t + "";
    }
  } else {
    m = "00";
  }
  return t;

}

//去掉html标签
export function replaceHtml(str) {
  if (str) {
    str = str ? str.replace(/<[^>]*>|<\/[^>]*>/gm, "") : '';
    str = str ? str.replace(/\n/g, "") : '';
    str = str ? str.replace(/&nbsp;/g, "") : '';
  }
  return str
}

function getShow(role, k) {
  return role ? role.indexOf(k) >= 0 : role.public.indexOf(k) >= 0
}

import { navlist } from "./settings";
//登录判断权限 跳转的页面 -登录跳转， 内页顶部导航跳转子页面用
export function loginNextPageShow() {
  let nvl = JSON.parse(JSON.stringify(navlist))
  if (localStorage.getItem('role')) {
    let role = JSON.parse(localStorage.getItem('role'));
    for (let k in nvl) {
      nvl[k].show = role.filter(function (v) { return nvl[k].role.indexOf(v) > -1 }).length > 0 ? true : false;
      if (nvl[k].show) {
        nvl[k].path = nvl[k].nextLevelPath.filter(r => role.indexOf(r.role) >= 0)[0].path;
      } else { //没有权限 但是子集有不需要权限的页面
        if (nvl[k].isShow) {
          nvl[k].path = nvl[k].nextLevelPath.filter(r => r.isShow).length > 0 ? nvl[k].nextLevelPath.filter(r => r.isShow)[0].path : ''
        }
      }
      // console.log(nvl[k].showName,nvl[k].path);
    }
    return nvl
  }
}

export function getRoleArr(roleName, key, proId) {
  //key community - 社区   forum -论坛
  let role = localStorage.getItem('role') ? JSON.parse(localStorage.getItem('role')) : false;
  // console.log(role.length,'role----');
  
  if (!role) {
    // Message.error('账号有误，请重新登录')
    router.replace('login')
  } else {
    if (key == 'community') {
      let proid = proId ? proId : getQueryString('proid')
      if ((role[key] && !role[key].public && role[key].indexOf(roleName) >= 0) || (role[key].public && role[key].public.indexOf(roleName) >= 0) ||
        (proid && role[key].list && role[key].list[proid] && role[key].list[proid].indexOf(roleName) >= 0)) {
        return true;
      } else {
        return false;
      }
    } else {
      // console.log(role.public.indexOf(roleName) >= 0,roleName,'aaa');
      return role.indexOf(roleName) >= 0
    }
    // if(key == 'community' && role[key].public){
    //   return role[key].public
    // }
  }
}

//随机字符串
export function randomString(e) {
  e = e || 7;
  var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
    a = t.length,
    n = "";
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n
}

export function weekFont(e) {
  const weekdays = ['一', '二', '三', '四', '五', '六', '日'];
  return weekdays[e - 1];
}

//txtarea处理
export function resetTextArea(e){
  return e ? e.replace(/\n/g, '<br/>') : '';
}

//控制小程序中图片大小
export function formatRichText(html) { 
  if (!html) return '';
  return html.replace(/\<img/gi, '<img style="width:100%;height:auto" ');
}